import React from 'react';
import { getNavIconClass } from '../../../../navigation/clinicNavConfig';

const SIZE_CLASS = {
    xs: 'web-bookings-icon--xs',
    sm: 'web-bookings-icon--sm',
    md: 'web-bookings-icon--md',
    lg: 'web-bookings-icon--lg',
    xl: 'web-bookings-icon--xl',
};

function WebBookingsIcon({ icon, theme = 'primary', size = 'md', className = '', round = false, children }) {
    const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

    return (
        <span
            className={`ecx-nav-icon ${getNavIconClass(theme)} web-bookings-icon ${sizeClass} ${
                round ? 'web-bookings-icon--round' : ''
            } ${className}`.trim()}
            aria-hidden={children ? undefined : 'true'}
        >
            {icon ? <i className={`bi ${icon}`} /> : null}
            {children}
        </span>
    );
}

export default WebBookingsIcon;
